import React, { useState } from 'react';
import Modal from '../shared/Modal';

function SchedulePostModal({ onClose, onSubmit, saving, messageContent }) {
  const [dates, setDates] = useState(['']);

  const addDate = () => setDates(prev => [...prev, '']);

  const removeDate = (index) => {
    if (dates.length <= 1) return;
    setDates(prev => prev.filter((_, i) => i !== index));
  };

  const updateDate = (index, value) => {
    setDates(prev => prev.map((d, i) => i === index ? value : d));
  };

  const allFilled = dates.every(d => d !== '');

  const handleSubmit = () => {
    if (!allFilled || saving) return;
    onSubmit(dates);
  };

  // Extrair preview dos titulos do conteudo do agente (linhas com > ou ## ou **)
  const extractPreviews = () => {
    if (!messageContent) return [];
    const lines = messageContent.split('\n');
    const titles = [];
    for (const line of lines) {
      const trimmed = line.trim();
      if (trimmed.startsWith('## Post') || trimmed.startsWith('## post')) {
        titles.push(trimmed.replace(/^##\s*/, ''));
      }
    }
    return titles;
  };

  const previews = extractPreviews();

  return (
    <Modal
      title="Aprovar e Enviar para Cliente"
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={!allFilled || saving}>
            {saving ? 'Enviando...' : `Enviar ${dates.length} post${dates.length > 1 ? 's' : ''}`}
          </button>
        </>
      }
    >
      <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem', marginBottom: 'var(--spacing-md)' }}>
        O conteudo do agente sera aprovado e enviado para a aba <strong>Aprovacoes</strong> do cliente. Escolha a(s) data(s) de publicacao.
      </p>

      {dates.map((date, index) => (
        <div key={index} style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacing-sm)',
          marginBottom: 'var(--spacing-sm)',
        }}>
          <span style={{ color: 'var(--color-text-muted)', fontSize: '0.85rem', minWidth: '70px' }}>
            Post {index + 1}
          </span>
          {previews[index] && (
            <span style={{
              color: 'var(--color-text-secondary)',
              fontSize: '0.75rem',
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
              {previews[index]}
            </span>
          )}
          <input
            className="form-input"
            type="date"
            value={date}
            onChange={(e) => updateDate(index, e.target.value)}
            style={{ width: '170px', flexShrink: 0 }}
          />
          {dates.length > 1 && (
            <button
              onClick={() => removeDate(index)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-danger)',
                cursor: 'pointer',
                fontSize: '1.1rem',
                padding: '0 4px',
              }}
              title="Remover"
            >
              &#x2715;
            </button>
          )}
        </div>
      ))}

      <button
        className="btn btn-secondary"
        onClick={addDate}
        style={{ width: '100%', marginTop: 'var(--spacing-sm)' }}
      >
        + Adicionar mais um post
      </button>
    </Modal>
  );
}

export default SchedulePostModal;
